module.exports = __webpack_public_path__ + "assets/img/fashion-img4-b9ff8bdf.png";